var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/html.js
// module id = 232
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35